import React from 'react';
import PageContentEditor from '../components/PageContentEditor';

const PagesTab = ({ pageContents, onUpdate }) => {
    return (
        <div className="space-y-6">
            {pageContents.map(page => (
                <PageContentEditor 
                    key={page.page_id} 
                    pageContent={page} 
                    onUpdate={onUpdate}
                />
            ))}
        </div>
    );
};

export default PagesTab;
